import {
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { LessonCollectableCategoryForm } from "../lesson-collectable-category-form";
import { LessonCollectableCategoryList } from "../lesson-collectable-category-list";
import { GamePlanSlide } from "../wizard/use-game-plan";
import { LessonCollectableFormStyles } from "./lesson-collectable-form.styles";

type Props = {
  slide: GamePlanSlide;
  onClose: () => void;
  onLessonCollectableSaveSuccess?: () => void;
};

export const LessonCollectableForm = (props: Props) => {
  const { slide, onClose, onLessonCollectableSaveSuccess } = props;
  const classes = LessonCollectableFormStyles();
  const [isAddCategoryFormOpen, setIsAddCategoryFormOpen] = useState(false);

  const isPremium = useSelector<RootState, boolean>(
    (state) => state.profile.isPremium
  );

  const showAddCategoryForm = () => {
    setIsAddCategoryFormOpen(true);
  };
  const hideAddCategoryForm = () => {
    setIsAddCategoryFormOpen(false);
  };

  return (
    <Paper className={classes.paper}>
      <Grid container style={{ justifyContent: "space-between" }}>
        <DialogTitle
          className={classes.dialogTitle}
          data-testid="alert-dialog-title"
          id="alert-dialog-title"
          title="Add Highlight"
        >
          Collect Item
        </DialogTitle>
        <IconButton
          data-testid="dialog-icon-btn-close"
          name="errors"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <DialogContent>
        <Grid container spacing={0}>
          {!isAddCategoryFormOpen && isPremium && (
            <>
              <Grid item xs={12} md={12}>
                <div className={classes.addCategory}>
                  <div
                    className={classes.addCategoryIcon}
                    onClick={showAddCategoryForm}
                  >
                    <AddIcon />
                  </div>
                  <span className={classes.addCategoryLabel}>
                    Create Category
                  </span>
                </div>
              </Grid>
            </>
          )}
          {isAddCategoryFormOpen && (
            <Grid item xs={12}>
              <LessonCollectableCategoryForm onClose={hideAddCategoryForm} />
            </Grid>
          )}
          <Grid item xs={12} className={classes.categoriesTitle}>
            Categories
          </Grid>
          <Grid item xs={12} />
          <LessonCollectableCategoryList
            slide={slide}
            onLessonCollectableSaveSuccess={onLessonCollectableSaveSuccess}
          />
        </Grid>
      </DialogContent>
    </Paper>
  );
};
